var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "viva-park-list-page" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-3 d-none d-xl-block d-lg-block d-md-block" },
        [
          _c(
            "div",
            { staticClass: "house-property-filtering opened" },
            [
              _c("h2", { staticClass: "filter-main-title" }, [
                _vm._v(_vm._s(_vm.trans("vivapark_filter_by_research"))),
              ]),
              _vm._l(_vm.propertyFilterTypes, function (name, index) {
                return _c(
                  "div",
                  {
                    key: "propety-filter-item-" + index,
                    class: { "house-property-filter": 1 },
                  },
                  [
                    _c("h3", [
                      _vm._v(
                        _vm._s(_vm.trans("vivapark_property_filter_" + name))
                      ),
                    ]),
                    _c("div", { class: { "house-property-filter-item": 1 } }, [
                      _c("div", {
                        class: {
                          "house-property-range-slider":
                            name != "house_comfort_number",
                          "house-property-range-slider-comfort":
                            name == "house_comfort_number",
                        },
                        attrs: { "data-property": name },
                      }),
                      _c(
                        "div",
                        { staticClass: "house-property-filter-pips row" },
                        [
                          _c("div", { staticClass: "col-4 text-left" }, [
                            _vm._v(
                              _vm._s(
                                _vm.trans("vivapark_property_filter_pip_1")
                              )
                            ),
                          ]),
                          _c("div", { staticClass: "col-4 text-center" }, [
                            _vm._v(
                              _vm._s(
                                _vm.trans("vivapark_property_filter_pip_2")
                              )
                            ),
                          ]),
                          _c("div", { staticClass: "col-4 text-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm.trans("vivapark_property_filter_pip_3")
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                )
              }),
              false
                ? _c(
                    "div",
                    { staticClass: "house-property-filtering-show-more" },
                    [
                      !_vm.openedFilters
                        ? _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.updatePropertyfilterState()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.trans("vivapark_property_filter_show_all")
                                ) + " "
                              ),
                              _c("span", {
                                staticClass: "mdi mdi-chevron-down",
                              }),
                            ]
                          )
                        : _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.updatePropertyfilterState()
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.trans(
                                    "vivapark_property_filter_show_less"
                                  )
                                ) + " "
                              ),
                              _c("span", { staticClass: "mdi mdi-chevron-up" }),
                            ]
                          ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "house-filtering-container" },
            [
              _c("h2", { staticClass: "filter-main-title" }, [
                _vm._v(_vm._s(_vm.trans("vivapark_filter_by_material"))),
              ]),
              _vm._l(_vm.data.filters, function (filter, index) {
                return _c(
                  "div",
                  {
                    key: "filter-group-" + index,
                    staticClass: "house-filter-group",
                  },
                  [
                    _c("h3", [_vm._v(_vm._s(filter.name))]),
                    _c(
                      "div",
                      { staticClass: "house-filter-items" },
                      _vm._l(
                        filter.filters,
                        function (filterLabel, filterKey, index2) {
                          return _c(
                            "a",
                            {
                              key: "filter-item-" + index2,
                              class:
                                "house-filter-item " +
                                (filterKey == filter ? "selected" : ""),
                              attrs: { href: "javascript:;" },
                              on: {
                                click: function ($event) {
                                  _vm.data.filter = filterKey
                                  return false
                                },
                              },
                            },
                            [_vm._v(_vm._s(filterLabel))]
                          )
                        }
                      ),
                      0
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ]
      ),
      _c("div", { staticClass: "col-md-9" }, [
        _vm.paginator.maxPage > 1
          ? _c(
              "div",
              { staticClass: "paginator text-right" },
              [
                _c("Paginator", {
                  attrs: { paginator: _vm.paginator },
                  on: { pageSelected: _vm.pageSelected },
                }),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "row house-list-container" },
          _vm._l(_vm.houses, function (house, index) {
            return _c(
              "div",
              {
                key: "house-" + index,
                staticClass: "col-12 col-sm-6 col-md-4 col-lg-3 pl-1 pr-1",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "card viva-park-house-card mb-2",
                    class: { disabledCard: !house.is_clickable },
                  },
                  [
                    _c("div", { staticClass: "house-card-top-image mb-3" }, [
                      _c("a", { attrs: { href: _vm.houseUrl(house) } }, [
                        _c("img", {
                          staticClass: "img-fluid",
                          attrs: { src: house.main_image, alt: house.house_nr },
                        }),
                      ]),
                    ]),
                    _c("a", { attrs: { href: _vm.houseUrl(house) } }, [
                      _c("h3", { staticClass: "mb-3" }, [
                        _vm._v(_vm._s(house.house_nr)),
                      ]),
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-6" }, [
                        _c("span", { staticClass: "property-label" }, [
                          _vm._v(_vm._s(_vm.trans("vivapark_wall_material"))),
                        ]),
                        _c("span", { staticClass: "property-value" }, [
                          _vm._v(_vm._s(house.wallMaterial)),
                        ]),
                      ]),
                      _c("div", { staticClass: "col-6" }, [
                        _c("span", { staticClass: "property-label" }, [
                          _vm._v(_vm._s(_vm.trans("vivapark_thickness"))),
                        ]),
                        _c("span", { staticClass: "property-value" }, [
                          _vm._v(
                            _vm._s(
                              house.wall_thickness ? house.wall_thickness : "-"
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-6" }, [
                        _c("span", { staticClass: "property-label" }, [
                          _vm._v(_vm._s(_vm.trans("vivapark_inner_plaster"))),
                        ]),
                        _c("span", {
                          staticClass: "property-value",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getProductLink(house.inner_coating_product)
                            ),
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "col-6" }, [
                        _c("span", { staticClass: "property-label" }, [
                          _vm._v(_vm._s(_vm.trans("vivapark_coating"))),
                        ]),
                        _c("span", {
                          staticClass: "property-value",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getProductLink(house.inner_paint_product)
                            ),
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-6" }, [
                        _c("span", { staticClass: "property-label" }, [
                          _vm._v(
                            _vm._s(_vm.trans("vivapark_insulation_material"))
                          ),
                        ]),
                        _c("span", {
                          staticClass: "property-value",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getProductLink(house.insulation_product)
                            ),
                          },
                        }),
                      ]),
                      _c("div", { staticClass: "col-6" }, [
                        _c("span", { staticClass: "property-label" }, [
                          _vm._v(_vm._s(_vm.trans("vivapark_thickness"))),
                        ]),
                        _c("span", { staticClass: "property-value" }, [
                          _vm._v(
                            _vm._s(
                              house.insulation_thickness
                                ? house.insulation_thickness
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "row vivapark-house-circle" }, [
                      _c("div", { staticClass: "col-5 text-center" }, [
                        [0, 1, 2, 3].indexOf(house.house_comfort_number) >= 0
                          ? _c("div", {
                              staticClass: "list-circle-anim",
                              attrs: {
                                "data-val": house.house_comfort_number,
                                id: "list-circle-" + house.id,
                                "data-toggle": "tooltip",
                                title: house.house_comfort,
                              },
                            })
                          : _vm._e(),
                      ]),
                      _c("div", { staticClass: "col-7" }, [
                        _c(
                          "span",
                          { staticClass: "property-label comfort-label" },
                          [_vm._v(_vm._s(_vm.trans("vivapark_house_comfort")))]
                        ),
                      ]),
                    ]),
                    false
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "vivapark-house-actions mt-5 text-right",
                          },
                          [
                            house.parameters && house.parameters.length
                              ? _c(
                                  "a",
                                  {
                                    staticClass:
                                      "vivapark-house-action addToVivaParkCompare mr-2",
                                    attrs: { "data-house-id": house.id },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "icon",
                                      attrs: {
                                        src: "/images/icons/compare.svg",
                                        alt: _vm.trans("vivapark_menu_compare"),
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "a",
                              {
                                staticClass: "vivapark-house-action",
                                attrs: {
                                  target: "_blank",
                                  href: _vm.get3dTourUrl(house),
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "icon",
                                  attrs: {
                                    src: "/images/icons/3d_icon.png",
                                    alt: _vm.trans("vivapark_menu_3d_tour"),
                                  },
                                }),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        class:
                          "vivapark-addtoCompare-item vivapark-addtoCompare-item-" +
                          house.id,
                      },
                      [
                        house.parameters && house.parameters.length
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "vivapark-house-action addToVivaParkCompare mr-2",
                                attrs: {
                                  "data-addtext": _vm.trans(
                                    "vivapark_addto_compare"
                                  ),
                                  "data-removetext": _vm.trans(
                                    "vivapark_removefrom_compare"
                                  ),
                                  "data-house-id": house.id,
                                  "data-moveditem":
                                    "<div><img class='icon' src='/images/icons/compare.svg'></div>",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.updateCompareButtons()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.trans("vivapark_addto_compare"))
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "vivapark-house-3d-action",
                        attrs: {
                          target: "_blank",
                          href: _vm.get3dTourUrl(house),
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "icon",
                          attrs: {
                            src: "/images/icons/3d_icon.png",
                            alt: _vm.trans("vivapark_menu_3d_tour"),
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]
            )
          }),
          0
        ),
        _vm.paginator.maxPage > 1
          ? _c(
              "div",
              { staticClass: "paginator text-right" },
              [
                _c("Paginator", {
                  attrs: { paginator: _vm.paginator },
                  on: { pageSelected: _vm.pageSelected },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }